/* eslint-disable import/prefer-default-export */
import { configureStore } from "@reduxjs/toolkit";
import retrofit from "./Retrofit/store/slices/retrofit";
import cartesianConfigurationReducer from "./Cartesian/store/slices/cartesian";
import commonReducer from "./Common/store/slices/common";
import mc12ConfigurationReducer from "./Mc12/store/slices/mc12";
import integratedDrivesReducer from "./IntegratedDrives/store/slices/integrated_drives";

export const store = configureStore({
  reducer: {
    common: commonReducer,
    retrofit,
    mc12: mc12ConfigurationReducer,
    cartesian: cartesianConfigurationReducer,
    integrated_drives: integratedDrivesReducer
  }
});
